<section class="home-wrapper">
  <div class="home-container">
    <!-- Header: titolo + numeri -->
    <header class="home-header">
      <div class="title-block">
        <div class="title-block-row">
          <span class="title-icon material-symbols-outlined" aria-hidden="true">article_shortcut</span>
          <div class="title-text">
            <h1 class="page-title">Referenze</h1>
          </div>
        </div>
        <!-- Tag selezionati come chip -->
        <div class="selected-tags-container" *ngIf="hasActiveFilters()">
            <!-- Tag BIM -->
            <span class="filter-chip bim-chip" *ngIf="bimOnly">
              <span class="chip-label">BIM</span>
              <button
                type="button"
                class="chip-remove"
                (click)="bimOnly = false; onFiltersChanged()"
                aria-label="Rimuovi filtro BIM"
              >
                <i class="pi pi-times"></i>
              </button>
            </span>
            <!-- Tag Servizi Affini -->
            <span class="filter-chip sa-chip" *ngIf="serviziAccessoriOnly">
              <span class="chip-label">Servizi Affini</span>
              <button
                type="button"
                class="chip-remove"
                (click)="serviziAccessoriOnly = false; onFiltersChanged()"
                aria-label="Rimuovi filtro servizi affini"
              >
                <i class="pi pi-times"></i>
              </button>
            </span>
            <!-- Filtri strutturati -->
            <span
              class="filter-chip soft-chip"
              *ngIf="selectedClienti.length"
              [pTooltip]="getClientiTooltip()"
              tooltipPosition="top"
            >
              <span class="chip-label">{{ getClientiChipLabel() }}</span>
              <button
                type="button"
                class="chip-remove"
                (click)="clearClientiFilter()"
                aria-label="Rimuovi filtro cliente"
              >
                <i class="pi pi-times"></i>
              </button>
            </span>
            <span
              class="filter-chip soft-chip"
              *ngIf="selectedProjectManagers.length"
              [pTooltip]="getProjectManagersTooltip()"
              tooltipPosition="top"
            >
              <span class="chip-label">{{ getProjectManagersChipLabel() }}</span>
              <button
                type="button"
                class="chip-remove"
                (click)="clearProjectManagersFilter()"
                aria-label="Rimuovi filtro project manager"
              >
                <i class="pi pi-times"></i>
              </button>
            </span>
            <span
              class="filter-chip soft-chip"
              *ngIf="selectedCategorieServizio.length"
              [pTooltip]="getCategorieServizioTooltip()"
              tooltipPosition="top"
            >
              <span class="chip-label">{{ getCategorieServizioChipLabel() }}</span>
              <button
                type="button"
                class="chip-remove"
                (click)="clearCategorieServizioFilter()"
                aria-label="Rimuovi filtro categorie servizio"
              >
                <i class="pi pi-times"></i>
              </button>
            </span>
            <!-- Filtro Commessa -->
            <span
              class="filter-chip soft-chip"
              *ngIf="selectedCommessa"
            >
              <span class="chip-label">{{ getCommessaChipLabel() }}</span>
              <button
                type="button"
                class="chip-remove"
                (click)="clearCommessaFilter()"
                aria-label="Rimuovi filtro commessa"
              >
                <i class="pi pi-times"></i>
              </button>
            </span>
            <!-- Filtro Certificato -->
            <span
              class="filter-chip soft-chip"
              *ngIf="selectedCertificato"
            >
              <span class="chip-label">{{ getCertificatoChipLabel() }}</span>
              <button
                type="button"
                class="chip-remove"
                (click)="clearCertificatoFilter()"
                aria-label="Rimuovi filtro certificato"
              >
                <i class="pi pi-times"></i>
              </button>
            </span>
            <!-- Filtro Ruoli -->
            <span
              class="filter-chip soft-chip ruoli-filter-chip"
              *ngIf="selectedRuoliFilter?.length"
              [pTooltip]="getRuoliFilterTooltip()"
              tooltipPosition="top"
            >
              <i class="pi pi-id-card chip-icon"></i>
              <span class="chip-label">{{ getRuoliFilterChipLabel() }}</span>
              <button
                type="button"
                class="chip-remove"
                (click)="clearRuoliFilter()"
                aria-label="Rimuovi filtro ruoli"
              >
                <i class="pi pi-times"></i>
              </button>
            </span>
            <!-- Filtro Persone -->
            <span
              class="filter-chip soft-chip persone-filter-chip"
              *ngIf="selectedPersoneFilter?.length"
              [pTooltip]="getPersoneFilterTooltip()"
              tooltipPosition="top"
            >
              <i class="pi pi-user chip-icon"></i>
              <span class="chip-label">{{ getPersoneFilterChipLabel() }}</span>
              <button
                type="button"
                class="chip-remove"
                (click)="clearPersoneFilter()"
                aria-label="Rimuovi filtro persone"
              >
                <i class="pi pi-times"></i>
              </button>
            </span>
            <!-- Tag selezionati -->
            <span
              class="filter-chip"
              *ngFor="let selectedTag of getSelectedTags()"
            >
              <span class="chip-label">{{ selectedTag.categoryName }}: {{ selectedTag.tagName }}</span>
              <button
                type="button"
                class="chip-remove"
                (click)="removeTag(selectedTag.categoryCode, selectedTag.tagCode)"
                [attr.aria-label]="'Rimuovi filtro ' + selectedTag.tagName"
              >
                <i class="pi pi-times"></i>
              </button>
            </span>
            <!-- Pulsante cancella tutto -->
            <button
              type="button"
              class="clear-all-filters"
              (click)="clearAllFilters()"
              aria-label="Cancella tutti i filtri"
              pTooltip="Cancella tutti i filtri"
              tooltipPosition="top"
            >
              <i class="pi pi-filter-slash"></i>
              <span>Pulisci</span>
            </button>
        </div>
      </div>
      <div class="header-actions">
        <button
          pButton
          type="button"
          icon="pi pi-plus"
          label="Nuova referenza"
          class="add-button p-button-rounded"
          aria-label="Aggiungi nuova referenza"
          (click)="openNuovaReferenzaWizard()"
          *ngIf="canModify()"
        ></button>
        <div class="stats-block">
          <div class="stat-card primary">
            <span class="stat-label">Totale</span>
            <span class="stat-value stat-value-total">{{ referenze.length }}</span>
          </div>
          <div class="stat-card secondary">
            <span class="stat-label">Filtrate</span>
            <span class="stat-value stat-value-filtered">{{ filteredReferenze.length }}</span>
          </div>
        </div>
      </div>
    </header>

    <!-- Sezione filtri -->
    <section class="filters-section">
      <div class="filters-header-row">
        <div class="filters-title">
          <i class="pi pi-filter"></i>
          <span>Filtra referenze</span>
        </div>
        <button
          pButton
          type="button"
          icon="pi pi-question-circle"
          class="help-button p-button-text p-button-rounded"
          (click)="openHelpDialog()"
          pTooltip="Guida all'uso dei filtri"
          tooltipPosition="left"
          aria-label="Mostra guida filtri"
        ></button>
      </div>

      <div class="filters-row">
        <div class="search-field">
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              [(ngModel)]="filterText"
              (ngModelChange)="onFiltersChanged()"
              placeholder="Cerca per titolo, cliente, PM, commessa, categorie servizio..."
            />
          </span>
        </div>

        <div class="filter-toggles">
          <div class="filter-toggle">
            <p-inputSwitch [(ngModel)]="bimOnly" (onChange)="onFiltersChanged()"></p-inputSwitch>
            <span class="filter-toggle-label">BIM</span>
          </div>
          <div class="filter-toggle">
            <p-inputSwitch
              [(ngModel)]="serviziAccessoriOnly"
              (onChange)="onFiltersChanged()"
            ></p-inputSwitch>
            <span
              class="filter-toggle-label"
              pTooltip="Mostra solo le referenze con servizi affini"
              tooltipPosition="top"
            >Servizi Aff.</span>
          </div>
        </div>
      </div>

      <!-- Riga combinata: filtri base (sx) + filtri ruoli (dx) -->
      <div
        class="filters-combined-row has-ruoli"
      >
        <!-- Colonna sinistra: Cliente, PM, Categorie servizio in righe -->
        <div class="filters-base-col filters-card">
          <!-- <div class="ruoli-row-divider">
            <i class="pi pi-filter ruoli-row-icon"></i>
            <span class="ruoli-row-label">Referenza</span>
          </div> -->
          <div class="filters-base-fields">
            <div class="filters-base-row filters-base-row--top">
              <div class="filter-field">
                <label class="filter-label">
                  <i class="pi pi-building"></i>
                  <span>Cliente</span>
                </label>
                <p-multiSelect
                  [options]="clienteOptions"
                  [(ngModel)]="selectedClienti"
                  (onChange)="onFiltersChanged()"
                  optionLabel="label"
                  optionValue="value"
                  display="chip"
                  [filter]="true"
                  placeholder="Seleziona cliente"
                  [showClear]="true"
                  [appendTo]="'body'"
                ></p-multiSelect>
              </div>
              <div class="filter-field">
                <label class="filter-label">
                  <i class="pi pi-user"></i>
                  <span>Project Manager</span>
                </label>
                <p-multiSelect
                  [options]="projectManagerOptions"
                  [(ngModel)]="selectedProjectManagers"
                  (onChange)="onFiltersChanged()"
                  optionLabel="label"
                  optionValue="value"
                  display="chip"
                  [filter]="true"
                  placeholder="Seleziona PM"
                  [showClear]="true"
                  [appendTo]="'body'"
                ></p-multiSelect>
              </div>
            </div>

            <div class="filters-base-row filters-base-row--bottom">
              <div class="filters-base-pair">
                <div class="filter-field">
                  <label class="filter-label">
                    <i class="pi pi-hashtag"></i>
                    <span>Numero Commessa</span>
                  </label>
                  <p-dropdown
                    [options]="commessaOptions"
                    [(ngModel)]="selectedCommessa"
                    (onChange)="onFiltersChanged()"
                    optionLabel="label"
                    optionValue="value"
                    [filter]="true"
                    filterPlaceholder="Cerca..."
                    placeholder="Commessa"
                    [showClear]="true"
                    [appendTo]="'body'"
                    styleClass="w-full"
                  ></p-dropdown>
                </div>
                <div class="filter-field">
                  <label class="filter-label">
                    <i class="pi pi-verified"></i>
                    <span>Certificato</span>
                  </label>
                  <p-dropdown
                    [options]="certificatoOptions"
                    [(ngModel)]="selectedCertificato"
                    (onChange)="onFiltersChanged()"
                    optionLabel="label"
                    optionValue="value"
                    [filter]="true"
                    filterPlaceholder="Cerca..."
                    placeholder="Certificato"
                    [showClear]="true"
                    [appendTo]="'body'"
                    styleClass="w-full"
                  ></p-dropdown>
                </div>
              </div>
              <div class="filter-field filter-field--cat">
                <label class="filter-label">
                  <i class="pi pi-sitemap"></i>
                  <span>Categorie servizio</span>
                </label>
                <p-multiSelect
                  [options]="categorieServizioOptions"
                  [(ngModel)]="selectedCategorieServizio"
                  (onChange)="onFiltersChanged()"
                  optionLabel="label"
                  optionValue="value"
                  display="chip"
                  [filter]="true"
                  placeholder="Categorie"
                  [showClear]="true"
                  [appendTo]="'body'"
                ></p-multiSelect>
              </div>
            </div>
          </div><!-- /filters-base-fields -->
        </div>

        <!-- Colonna destra: filtri ruoli assegnati -->
        <div
          class="filters-ruoli-col"
        >
          <div class="ruoli-row-divider">
            <i class="pi pi-id-card ruoli-row-icon"></i>
            <span class="ruoli-row-label">Ruoli</span>
          </div>
          <div class="ruoli-row-fields">
            <div class="filter-field">
              <label class="filter-label">
                <i class="pi pi-briefcase"></i>
                <span>Tipo ruolo</span>
              </label>
              <p-multiSelect
                #ruoliFilter
                styleClass="ruoli-filter-multiselect"
                [options]="filteredRuoliFilterOptions"
                [(ngModel)]="selectedRuoliFilter"
                (onChange)="onRuoliFilterChanged()"
                optionLabel="label"
                optionValue="value"
                display="chip"
                [filter]="true"
                filterPlaceholder="Cerca ruolo..."
                [placeholder]="(selectedPersoneFilter || []).length ? 'Ruoli della persona selezionata' : 'Tutti i ruoli'"
                [showClear]="true"
                [appendTo]="'body'"
              >
                <ng-template let-opt pTemplate="item">
                  <div class="ruoli-filter-option-item">
                    <span class="ruoli-filter-codice">{{ opt.codice }}</span>
                    <span class="ruoli-filter-desc">{{ opt.label }}</span>
                  </div>
                </ng-template>
              <ng-template let-opt pTemplate="selectedItem">
                <span class="ruoli-filter-chip-label">{{ opt.label }}</span>
              </ng-template>
              </p-multiSelect>
            </div>
            <div class="filter-field">
              <label class="filter-label">
                <i class="pi pi-users"></i>
                <span>Persona coinvolta</span>
              </label>
              <p-multiSelect
                #personeFilter
                styleClass="persone-filter-multiselect"
                [options]="filteredPersoneFilterOptions"
                [(ngModel)]="selectedPersoneFilter"
                (onChange)="onPersoneFilterChanged()"
                optionLabel="label"
                optionValue="value"
                display="chip"
                [filter]="true"
                [resetFilterOnHide]="true"
                filterPlaceholder="Cerca persona..."
                [placeholder]="(selectedRuoliFilter || []).length ? 'Persone con il ruolo selezionato' : 'Tutte le persone'"
                [showClear]="true"
                [appendTo]="'body'"
              ></p-multiSelect>
            </div>
          </div>
        </div>
      </div>

      <!-- Filtri tag per categoria (nuovo modello a 5 categorie principali) -->
      <div class="tag-filters">
        <div class="tag-filters-header">
          <h3 class="tag-filters-title">
            <i class="pi pi-tags tag-filters-icon" aria-hidden="true"></i>
            <span>Tags</span>
          </h3>
        </div>
        <ng-container *ngIf="groupedCategories.length > 0; else noTagFilters">
          <div class="tag-filters-row">
            <div
              class="tag-filter-group"
              *ngFor="let group of groupedCategories"
              [attr.data-group-name]="group.groupName"
            >
              <div class="tag-group-header">
                <h3 class="tag-group-title">
                  <span *ngIf="group.groupIcon" class="material-symbols-outlined tag-group-icon">
                    {{ group.groupIcon }}
                  </span>
                  <!-- Titolo modulo: solo codice categoria -->
                  {{ group.groupLabel }}
                </h3>
              </div>
              <div class="tag-group-content">
                <div
                  class="tag-filter-card"
                  *ngFor="let cat of group.categories"
                >
                  <p-multiSelect
                    class="tag-multiselect"
                    [options]="getTagOptionsForCategory(cat.key)"
                    [(ngModel)]="selectedTagsByCategory[cat.key]"
                    (onChange)="onFiltersChanged()"
                    optionLabel="label"
                    optionValue="value"
                    display="chip"
                    [filter]="enableTagSearch"
                    [showHeader]="false"
                    [showClear]="true"
                    [appendTo]="'body'"
                    placeholder="Seleziona"
                  >
                    <ng-template pTemplate="footer">
                      <div style="padding: 0.5rem; text-align: right;">
                        <button
                          pButton
                          type="button"
                          icon="pi pi-plus"
                          label="Nuovo Tag"
                          class="p-button-text p-button-sm new-tag-button"
                          (click)="onCreateNewTagFromDropdown(cat.key)"
                          *ngIf="canModify()"
                        ></button>
                      </div>
                    </ng-template>
                  </p-multiSelect>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #noTagFilters>
          <div class="tag-filters-empty">
            Nessun filtro tag disponibile.
          </div>
        </ng-template>
      </div>
    </section>

    <!-- Sezione risultati -->
    <section class="results-section" *ngIf="filteredReferenze.length; else noResults">
      <div class="results-card">
        <div class="results-header">
          <div class="results-title">
            <i class="pi pi-list-check"></i>
            <span>Referenze trovate</span>
            <span class="results-count">({{ filteredReferenze.length }})</span>
          </div>
          <div class="results-actions">
            <div class="export-share-buttons">
              <button
                pButton
                type="button"
                icon="pi pi-file-excel"
                label="Esporta"
                class="export-excel-button p-button-outlined"
                (click)="exportToExcel()"
                [disabled]="filteredReferenze.length === 0"
                pTooltip="Scarica i risultati in formato Excel"
                tooltipPosition="top"
              ></button>
              <button
                pButton
                type="button"
                icon="pi pi-share-alt"
                label="Condividi"
                class="share-button p-button-outlined"
                aria-label="Condividi risultati ricerca"
                (click)="openShareMenu($event)"
                pTooltip="Condividi questa ricerca con altri colleghi"
                tooltipPosition="top"
              ></button>
            </div>
            <div class="view-toggle" aria-label="Selettore vista risultati">
              <button
                pButton
                type="button"
                label="Tabella"
                icon="pi pi-list"
                class="p-button-text toggle-button"
                [ngClass]="{ 'toggle-button-active': viewMode === 'table' }"
                (click)="viewMode = 'table'"
              ></button>
              <button
                pButton
                type="button"
                label="Griglia"
                icon="pi pi-th-large"
                class="p-button-text toggle-button"
                [ngClass]="{ 'toggle-button-active': viewMode === 'grid' }"
                (click)="viewMode = 'grid'"
              ></button>
              <button
                pButton
                type="button"
                label="Mappa"
                icon="pi pi-map"
                class="p-button-text toggle-button"
                [ngClass]="{ 'toggle-button-active': viewMode === 'map' }"
                (click)="viewMode = 'map'"
              ></button>
            </div>
          </div>
        </div>
        <div class="results-content">
          <!-- Vista tabellare -->
          <p-table
            *ngIf="viewMode === 'table'"
            [value]="filteredReferenze"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[10, 25, 50]"
        [resizableColumns]="true"
        [responsiveLayout]="'scroll'"
        class="results-table"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pResizableColumn style="min-width: 220px">Titolo</th>
            <th pResizableColumn style="min-width: 160px">Cliente</th>
            <th pResizableColumn style="min-width: 100px; text-align: center;">Commessa</th>
            <th pResizableColumn style="min-width: 140px; text-align: center;">Certificati</th>
            <th pResizableColumn style="min-width: 140px; text-align: center;">Importo Lavori</th>
            <th pResizableColumn style="min-width: 140px; text-align: center;">Importo Servizio</th>
            <th pResizableColumn class="centered-header" style="max-width: 60px; text-align: center;">Quota</th>
            <th pResizableColumn class="centered-header" style="max-width: 50px; text-align: center;">BIM</th>
            <th pResizableColumn class="centered-header" style="max-width: 50px; text-align: center;">AQ</th>
            <th pResizableColumn class="centered-header" style="min-width: 140px; text-align: center;">Data Fine</th>
            <th pResizableColumn class="centered-header" style="min-width: 120px; text-align: center;">Servizi Affini</th>
           <!--  <th pResizableColumn style="min-width: 140px">Project Manager</th>
            <th pResizableColumn style="min-width: 120px">RTP / Capogruppo</th>
            <th pResizableColumn style="min-width: 120px">In AQ</th> -->
            <!-- Colonna Categorie servizio spostata nel dialog dedicato -->
            <!-- Colonne tag commentate temporaneamente -->
            <!-- <th
              pResizableColumn
              *ngFor="let group of groupedCategories"
              [style.min-width.px]="200"
              class="tag-group-column"
            >
              <div class="column-header">
                <span class="material-symbols-outlined column-icon" *ngIf="group.groupIcon">{{ group.groupIcon }}</span>
                <span>{{ group.groupLabel }}</span>
              </div>
            </th> -->
            <th style="text-align: center;" pResizableColumn style="min-width: 120px"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-ref>
          <tr>
            <td>
              <div class="cell-main">
                <div
                  class="cell-title"
                  [pTooltip]="ref.titoloEsteso"
                  tooltipPosition="top"
                  [tooltipDisabled]="!ref.titoloEsteso"
                >
                  {{ ref.titoloBreve }}
                </div>
              </div>
            </td>
            <td>
              <span class="pill" *ngIf="ref.cliente; else noCliente">
                {{ ref.cliente }}
              </span>
              <ng-template #noCliente>
                <span class="text-muted">N/D</span>
              </ng-template>
            </td>
            <td style="text-align: center;">
              <span
                *ngIf="ref.codiceCommerciale; else noCodiceCommessa"
                class="codice-commessa-badge"
              >
                {{ ref.codiceCommerciale }}
              </span>
              <ng-template #noCodiceCommessa>
                <!-- <span class="text-muted">N/D</span> -->
              </ng-template>
            </td>
            <td style="text-align: center;">
              <div class="certificati-container" *ngIf="getCertificati(ref).length > 0; else noCertificati">
                <span class="certificato-chip" *ngFor="let cert of getCertificati(ref)">
                  <i class="pi pi-certificate"></i>
                  {{ cert }}
                </span>
              </div>
              <ng-template #noCertificati>
                <!-- <span class="text-muted">-</span> -->
              </ng-template>
            </td>
            <td style="text-align: center;">
              <div class="import-card import-lavori" *ngIf="ref.importoLavori !== null && ref.importoLavori !== undefined; else noImportoLavori">
               <!--  <div class="import-icon">
                  <i class="pi pi-briefcase"></i>
                </div> -->
                <div class="import-content">
                  <span class="import-amount">{{ formatImporto(ref.importoLavori) }}</span>
                </div>
              </div>
              <ng-template #noImportoLavori>
                <span class="import-empty">-</span>
              </ng-template>
            </td>
            <td style="text-align: center;">
              <div class="import-card import-servizio" *ngIf="ref.importoServizio !== null && ref.importoServizio !== undefined; else noImportoServizio">
             <!--    <div class="import-icon">
                  <i class="pi pi-cog"></i>
                </div> -->
                <div class="import-content">
                  <span class="import-amount">{{ formatImporto(ref.importoServizio) }}</span>
                </div>
              </div>
              <ng-template #noImportoServizio>
                <span class="import-empty">-</span>
              </ng-template>
            </td>
            <td style="text-align: center;">
              <span
                class="quota-badge"
                *ngIf="ref.quotaCooprogetti !== null && ref.quotaCooprogetti !== undefined; else noQuota"
                [pTooltip]="getQuotaTooltip(ref)"
                tooltipPosition="top"
                [tooltipDisabled]="!hasQuotaTooltip(ref)"
              >
                {{ formatQuota(ref.quotaCooprogetti) }}
              </span>
              <ng-template #noQuota>
                <!-- <span class="text-muted">N/D</span> -->
              </ng-template>
            </td>
            <td style="text-align: center;">
              <span class="bim-badge" [ngClass]="{'bim-active': (ref.bim === true), 'bim-inactive': (ref.bim !== true)}">
                <i class="pi" [ngClass]="(ref.bim === true) ? 'pi-check-circle' : 'pi-times-circle'"></i>
              </span>
            </td>
            <td style="text-align: center;">
              <span class="aq-badge" [ngClass]="{'aq-active': (ref.inAq === true), 'aq-inactive': (ref.inAq !== true)}">
                <span class="aq-text">AQ</span>
              </span>
            </td>
            <td style="text-align: center;">
              <div class="date-cell" *ngIf="ref.dataFine; else noDataFine">
                <span class="date-badge">
                  <span class="date-value">{{ ref.dataFine | date: 'dd/MM/yyyy' }}</span>
                </span>
              </div>
              <ng-template #noDataFine>
<!--                 <span class="text-muted">N/D</span>
 -->              </ng-template>
            </td>
            <td style="text-align: center;">
              <button
                type="button"
                class="sa-badge"
                [ngClass]="ref.serviziAccessoriPresenti === true ? 'sa-badge--yes' : 'sa-badge--no'"
                (click)="openServiziAccessoriDialog(ref)"
                [pTooltip]="ref.serviziAccessoriPresenti === true ? 'Servizi affini presenti – clicca per dettagli' : 'Nessun servizio affine – clicca per aggiungere'"
                tooltipPosition="top"
              >
                <i class="pi" [ngClass]="ref.serviziAccessoriPresenti === true ? 'pi-link' : 'pi-ban'"></i>
              </button>
            </td>
         <!--    <td>
              <span class="pill pill-soft" *ngIf="ref.projectManager; else noPM">
                {{ ref.projectManager }}
              </span>
              <ng-template #noPM>
                <span class="text-muted">N/D</span>
              </ng-template>
            </td>
            <td>
              <div class="flags">
                <span class="flag-chip success" *ngIf="ref.rtp">RTP</span>
                <span class="flag-chip info" *ngIf="ref.capogruppo">Capogruppo</span>
                <span class="text-muted" *ngIf="!ref.rtp && !ref.capogruppo">-</span>
              </div>
            </td>
            <td>
              <span
                class="flag-chip"
                [ngClass]="ref.inAq ? 'success' : 'neutral'"
              >
                {{ ref.inAq ? 'In AQ' : 'Fuori AQ' }}
              </span>
            </td>
            <td>
              <span *ngIf="ref.dataFine; else noData">
                {{ ref.dataFine | date: 'dd/MM/yyyy' }}
              </span>
              <ng-template #noData>
                <span class="text-muted">N/D</span>
              </ng-template>
            </td> -->
            <!-- Celle tag commentate temporaneamente -->
            <!-- <td
              *ngFor="let group of groupedCategories"
            >
              <div class="tag-badges" *ngIf="getTagsByGroup(ref, group.groupName).length > 0; else noTag">
                <span
                  class="tag-badge"
                  *ngFor="let tag of getTagsByGroup(ref, group.groupName)"
                  [style.background-color]="getTagColor(tag)"
                  [style.color]="getTagTextColor(tag)"
                >
                  {{ getTagDisplayName(tag) }}
                </span>
              </div>
              <ng-template #noTag>
                <span class="text-muted">—</span>
              </ng-template>
            </td> -->
            <td>
              <div class="action-buttons">
                <!-- Gruppo visualizzazione -->
                <button
                  pButton
                  type="button"
                  icon="pi pi-tags"
                  [class]="(ref.tag && ref.tag.length > 0) ? 'p-button-text p-button-sm btn-stato btn-stato--set' : 'p-button-text p-button-sm btn-stato btn-stato--missing'"
                  (click)="openTagsDialog(ref)"
                  [pTooltip]="(ref.tag && ref.tag.length > 0) ? 'Tag presenti – clicca per visualizzare' : 'Nessun tag associato'"
                  tooltipPosition="top"
                ></button>
                <button
                  pButton
                  type="button"
                  icon="pi pi-id-card"
                  [class]="(ref.ruoliProfili && ref.ruoliProfili.length > 0) ? 'p-button-text p-button-sm btn-stato btn-stato--set' : 'p-button-text p-button-sm btn-stato btn-stato--missing'"
                  (click)="openRuoliDialog(ref)"
                  [pTooltip]="(ref.ruoliProfili && ref.ruoliProfili.length > 0) ? 'Ruoli assegnati – clicca per visualizzare' : 'Nessun ruolo assegnato'"
                  tooltipPosition="top"
                ></button>
                <button
                  pButton
                  type="button"
                  icon="pi pi-list"
                  [class]="(ref.categorieServizio && ref.categorieServizio.length > 0) ? 'p-button-text p-button-sm btn-stato btn-stato--set' : 'p-button-text p-button-sm btn-stato btn-stato--missing'"
                  (click)="openCategoriServizioDialog(ref)"
                  [pTooltip]="(ref.categorieServizio && ref.categorieServizio.length > 0) ? 'Servizi associati – clicca per visualizzare' : 'Nessun servizio associato'"
                  tooltipPosition="top"
                ></button>
                <!-- Gruppo stato -->
                <button
                  pButton
                  type="button"
                  icon="pi pi-map-marker"
                  [class]="ref.posizione ? 'p-button-text p-button-sm btn-stato btn-stato--set' : 'p-button-text p-button-sm btn-stato btn-stato--missing'"
                  (click)="openPosizioneDialog(ref)"
                  [pTooltip]="ref.posizione ? 'Posizione impostata – clicca per modificare' : 'Posizione mancante – clicca per impostare'"
                  tooltipPosition="top"
                  *ngIf="canModify()"
                ></button>
                <!-- Divisore -->
                <span class="action-divider" *ngIf="canModify()"></span>
                <!-- Gruppo modifica -->
                <button
                  pButton
                  type="button"
                  icon="pi pi-pencil"
                  class="p-button-text p-button-sm"
                  (click)="openEditReferenzaWizard(ref)"
                  pTooltip="Modifica referenza"
                  tooltipPosition="top"
                  *ngIf="canModify()"
                ></button>
                <button
                  pButton
                  type="button"
                  icon="pi pi-trash"
                  class="p-button-text p-button-sm p-button-danger"
                  (click)="confirmDeleteReferenza(ref)"
                  pTooltip="Elimina referenza"
                  tooltipPosition="top"
                  *ngIf="canModify()"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!-- Vista mappa -->
      <div *ngIf="viewMode === 'map'" style="display:flex; flex-direction: column; gap: 0.75rem;">
       <!--  <div style="display:flex; align-items:center; justify-content: space-between; gap: 1rem;">
          <small style="color: var(--text-color-secondary);">
            Mostrate {{ filteredReferenzeWithPosizione.length }} referenze con posizione
            <span *ngIf="mapMissingPosizioneCount > 0">
              · {{ mapMissingPosizioneCount }} senza posizione (nascoste)
            </span>
          </small>
        </div> -->

        <app-leaflet-map
          [heightPx]="560"
          [center]="{ lat: 41.9, lng: 12.5 }"
          [zoom]="5"
          [markers]="mapMarkers"
          [clusterMarkers]="true"
        ></app-leaflet-map>
      </div>

      <!-- Vista griglia -->
      <div class="cards-grid" *ngIf="viewMode === 'grid'">
        <article class="referenza-card" *ngFor="let ref of filteredReferenze">
          <header class="referenza-card-header">
            <div class="title-area">
              <h3 class="card-title">{{ ref.titoloBreve }}</h3>
              <p class="card-subtitle" *ngIf="ref.titoloEsteso">
                {{ ref.titoloEsteso }}
              </p>
            </div>
            <div class="badge-area">
              <span class="flag-chip success" *ngIf="ref.rtp">RTP</span>
              <span class="flag-chip info" *ngIf="ref.capogruppo">Capogruppo</span>
            </div>
          </header>

          <section class="referenza-card-body">
            <div class="meta-row">
              <div class="meta-item">
                <span class="meta-label">Cliente</span>
                <span class="meta-value">
                  {{ ref.cliente || 'N/D' }}
                </span>
              </div>
              <div class="meta-item">
                <span class="meta-label">Project Manager</span>
                <span class="meta-value">
                  {{ ref.projectManager || 'N/D' }}
                </span>
              </div>
            </div>

            <div class="meta-row" *ngIf="ref.codiceCommerciale || getCertificati(ref).length > 0">
              <div class="meta-item" *ngIf="ref.codiceCommerciale">
                <span class="meta-label">Commessa</span>
                <span class="meta-value">
                  <span class="codice-commessa-badge">{{ ref.codiceCommerciale }}</span>
                </span>
              </div>
              <div class="meta-item" *ngIf="getCertificati(ref).length > 0">
                <span class="meta-label">Certificati</span>
                <div class="certificati-container-card">
                  <span class="certificato-chip" *ngFor="let cert of getCertificati(ref)">
                    <i class="pi pi-certificate"></i>
                    {{ cert }}
                  </span>
                </div>
              </div>
            </div>

            <div class="meta-row">
              <div class="meta-item">
                <span class="meta-label">Data fine</span>
                <span class="meta-value">
                  {{ ref.dataFine ? (ref.dataFine | date: 'dd/MM/yyyy') : 'N/D' }}
                </span>
              </div>
              <div class="meta-item">
                <span class="meta-label">Stato AQ</span>
                <span
                  class="flag-chip"
                  [ngClass]="ref.inAq ? 'success' : 'neutral'"
                >
                  {{ ref.inAq ? 'In AQ' : 'Fuori AQ' }}
                </span>
              </div>
            </div>

            <div class="chips-row" *ngIf="ref.categorieServizio.length">
              <span class="chips-label">Categorie</span>
              <div class="chips">
                <span class="chip" *ngFor="let cat of ref.categorieServizio">
                  {{ cat }}
                </span>
              </div>
            </div>

            <div class="chips-row" *ngIf="ref.tag.length">
              <span class="chips-label">Tag</span>
              <div class="tag-badges-grid">
                <span
                  class="tag-badge-large"
                  *ngFor="let tag of ref.tag"
                  [style.background-color]="getTagColor(tag)"
                  [style.color]="getTagTextColor(tag)"
                >
                  <span class="tag-category">{{ getTagCategoryName(tag) }}</span>
                  <span class="tag-separator">:</span>
                  <span class="tag-code">{{ getTagDisplayName(tag) }}</span>
                </span>
              </div>
            </div>
          </section>
        </article>
      </div>
        </div>
      </div>
    </section>

    <ng-template #noResults>
      <section class="empty-state">
        <div class="empty-card">
          <i class="pi pi-folder-open empty-icon"></i>
          <h2>Nessuna referenza trovata</h2>
          <p>
            Non sono presenti referenze in base ai criteri di ricerca correnti.
            Modifica i filtri o verifica i dati presenti in Firestore.
          </p>
        </div>
      </section>
    </ng-template>
  </div>
</section>

<!-- Wizard Nuova/Modifica Referenza -->
<app-nuova-referenza-wizard
  [(visible)]="showNuovaReferenzaWizard"
  [referenzaToEdit]="referenzaToEdit"
  (referenzaCreated)="onReferenzaCreated()"
  (wizardClosed)="referenzaToEdit = null"
></app-nuova-referenza-wizard>

<!-- Dialog Posizione Referenza -->
<app-posizione-referenza-dialog
  [(visible)]="showPosizioneDialog"
  [referenza]="selectedReferenzaForPosizione"
  [canModify]="canModify()"
  (posizioneSaved)="onPosizioneSaved()"
></app-posizione-referenza-dialog>

<!-- Dialog Servizi Affini -->
<p-dialog
  [(visible)]="showServiziAccessoriDialog"
  *ngIf="selectedReferenzaForServiziAccessori"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{
    width: selectedReferenzaForServiziAccessori.serviziAccessoriPresenti === true ? 'min(1100px, 96vw)' : 'auto',
    maxWidth: selectedReferenzaForServiziAccessori.serviziAccessoriPresenti === true ? '96vw' : '520px',
    minWidth: selectedReferenzaForServiziAccessori.serviziAccessoriPresenti === true ? '720px' : '360px'
  }"
  [styleClass]="selectedReferenzaForServiziAccessori.serviziAccessoriPresenti === true ? 'sa-dialog sa-dialog--wide' : 'sa-dialog'"
  (onHide)="closeServiziAccessoriDialog()"
>
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <div class="dialog-title">
        <i
          class="pi pi-link dialog-icon"
          [class.sa-icon--active]="selectedReferenzaForServiziAccessori.serviziAccessoriPresenti === true"
        ></i>
        <div class="title-content">
          <h2>Servizi Affini</h2>
          <p class="title-subtitle">
            {{ selectedReferenzaForServiziAccessori.titoloBreve }}
          </p>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="sa-dialog-body">
    <div
      class="sa-info-banner"
      *ngIf="selectedReferenzaForServiziAccessori.serviziAccessoriPresenti !== true"
    >
      <i class="pi pi-info-circle"></i>
      <span>Nessun servizio affine presente per questa referenza.</span>
    </div>

    <div class="sa-form-field">
      <label class="sa-url-label" for="sa-url-input">URL Servizi Affini</label>
      <div
        class="sa-url-group"
        [class.sa-url-group--with-actions]="selectedReferenzaForServiziAccessori.serviziAccessoriPresenti === true"
      >
        <span class="sa-url-prefix" aria-hidden="true">
          <i class="pi pi-globe"></i>
        </span>
        <input
          id="sa-url-input"
          type="url"
          [(ngModel)]="serviziAccessoriUrl"
          placeholder="https://esempio.it/link"
          class="sa-url-input"
          [disabled]="!canModify()"
        />
        <div
          class="sa-url-actions"
          *ngIf="selectedReferenzaForServiziAccessori.serviziAccessoriPresenti === true"
        >
          <button
            type="button"
            class="sa-url-action"
            pTooltip="Copia URL"
            tooltipPosition="top"
            [disabled]="!serviziAccessoriUrl"
            (click)="copyServiziAccessoriUrl()"
            aria-label="Copia URL"
          >
            <i class="pi pi-copy"></i>
          </button>
          <a
            *ngIf="serviziAccessoriUrl"
            [href]="serviziAccessoriUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="sa-url-action"
            pTooltip="Apri URL"
            tooltipPosition="top"
            aria-label="Apri URL"
          >
            <i class="pi pi-external-link"></i>
          </a>
          <button
            *ngIf="!serviziAccessoriUrl"
            type="button"
            class="sa-url-action"
            disabled
            aria-label="Apri URL"
          >
            <i class="pi pi-external-link"></i>
          </button>
        </div>
      </div>
      <small
        class="sa-url-hint"
        *ngIf="selectedReferenzaForServiziAccessori.serviziAccessoriPresenti !== true"
      >
        Inserisci il link da associare ai servizi affini.
      </small>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="sa-dialog-footer" *ngIf="canModify()">
      <button
        pButton
        type="button"
        label="Annulla"
        class="p-button-text"
        (click)="closeServiziAccessoriDialog()"
      ></button>
      <button
        pButton
        type="button"
        [label]="selectedReferenzaForServiziAccessori.serviziAccessoriPresenti === true ? 'Salva' : 'Attiva servizi affini'"
        [icon]="selectedReferenzaForServiziAccessori.serviziAccessoriPresenti === true ? 'pi pi-save' : 'pi pi-check'"
        [class]="selectedReferenzaForServiziAccessori.serviziAccessoriPresenti === true ? 'p-button-sm' : 'p-button-sm p-button-success'"
        [loading]="savingServiziAccessori"
        [disabled]="!canSaveServiziAccessori()"
        (click)="saveServiziAccessori()"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<!-- Dialog Categorie Servizio Referenza -->
<p-dialog
  [(visible)]="showCategoriServizioDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'auto', maxWidth: '480px', minWidth: '300px' }"
  styleClass="categorie-servizio-dialog"
  (onHide)="closeCategoriServizioDialog()"
>
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <div class="dialog-title">
        <i class="pi pi-list dialog-icon"></i>
        <div class="title-content">
          <h2>Categorie Servizi</h2>
          <p class="title-subtitle" *ngIf="selectedReferenzaForCategoriServizio">
            {{ selectedReferenzaForCategoriServizio.titoloBreve }}
          </p>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="dialog-content">
    <!-- Badge correnti -->
    <ng-container *ngIf="selectedReferenzaForCategoriServizio && selectedReferenzaForCategoriServizio.categorieServizio && selectedReferenzaForCategoriServizio.categorieServizio.length > 0; else noServizi">
      <div class="servizi-badges">
        <span
          class="servizio-badge"
          *ngFor="let cat of selectedReferenzaForCategoriServizio.categorieServizio"
        >
          {{ cat }}
          <button
            *ngIf="canModify()"
            type="button"
            class="servizio-badge-remove"
            (click)="confirmRemoveCategoriaServizio(cat)"
            [disabled]="savingCategoriaServizio"
            pTooltip="Rimuovi"
            tooltipPosition="top"
          ><i class="pi pi-times"></i></button>
        </span>
      </div>
    </ng-container>
    <ng-template #noServizi>
      <div class="empty-state">
<!--         <i class="pi pi-list empty-icon"></i>
 -->        <p>Nessuna categoria di servizio associata a questa referenza.</p>
      </div>
    </ng-template>

    <!-- Form aggiunta -->
    <div class="add-servizio-section" *ngIf="canModify()">
      <div class="add-servizio-header">
        <i class="pi pi-plus-circle"></i>
        <h4>Aggiungi categoria</h4>
      </div>
      <div class="add-servizio-form">
        <p-dropdown
          [options]="getCategoriServizioOptions()"
          [(ngModel)]="newCategoriaServizio"
          optionLabel="label"
          optionValue="value"
          placeholder="Seleziona categoria"
          [showClear]="true"
          [filter]="true"
          filterPlaceholder="Cerca..."
          appendTo="body"
          [overlayOptions]="{ baseZIndex: 2200000 }"
          [style]="{ width: '100%' }"
        ></p-dropdown>
        <button
          pButton
          type="button"
          icon="pi pi-plus"
          label="Aggiungi"
          class="p-button-primary p-button-sm"
          [disabled]="!newCategoriaServizio || savingCategoriaServizio"
          [loading]="savingCategoriaServizio"
          (click)="addCategoriaServizio()"
        ></button>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Chiudi"
      icon="pi pi-times"
      class="p-button-text"
      (click)="closeCategoriServizioDialog()"
    ></button>
  </ng-template>
</p-dialog>

<!-- Dialog Tag Referenza -->
<p-dialog
  [(visible)]="showTagsDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '90vw', maxWidth: '800px' }"
  styleClass="tags-dialog"
  (onHide)="closeTagsDialog()"
>
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <div class="dialog-title">
        <i class="pi pi-tags dialog-icon"></i>
        <div class="title-content">
          <h2>Tag della Referenza</h2>
          <p class="title-subtitle" *ngIf="selectedReferenzaForTags">
            {{ selectedReferenzaForTags.titoloBreve }}
          </p>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="dialog-content">
    <div class="tags-container" *ngIf="selectedReferenzaForTags && getGroupedTagsForReferenza(selectedReferenzaForTags).length > 0; else noTags">
      <div
        class="tag-group-card"
        *ngFor="let group of getGroupedTagsForReferenza(selectedReferenzaForTags)"
      >
        <div class="tag-group-header">
          <span class="material-symbols-outlined tag-group-icon" *ngIf="group.groupIcon">
            {{ group.groupIcon }}
          </span>
          <h3 class="tag-group-title">{{ group.groupLabel }}</h3>
        </div>
        <div class="tag-group-content">
          <div
            class="tag-item"
            *ngFor="let tag of group.tags"
          >
            <span
              class="tag-badge-large"
              [style.background-color]="getTagColor(tag)"
              [style.color]="getTagTextColor(tag)"
            >
              <span class="tag-category">{{ getTagCategoryName(tag) }}</span>
              <span class="tag-separator">:</span>
              <span class="tag-code">{{ getTagDisplayName(tag) }}</span>
              <button
                type="button"
                class="tag-delete-btn"
                (click)="confirmDeleteTagFromReferenza(tag)"
                pTooltip="Rimuovi tag"
                tooltipPosition="top"
                *ngIf="canModify()"
              >
                <i class="pi pi-times"></i>
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
    <ng-template #noTags>
      <div class="empty-tags-state">
        <i class="pi pi-tags empty-icon"></i>
        <p>Nessun tag associato a questa referenza</p>
      </div>
    </ng-template>

    <!-- Form per aggiungere nuovi tag -->
    <div class="add-tag-section" *ngIf="selectedReferenzaForTags && canModify()">
      <div class="add-tag-header">
        <h4>Aggiungi Tag</h4>
      </div>
      <div class="add-tag-form">
        <div class="form-row">
          <div class="form-field">
            <label for="category-select">Categoria</label>
            <p-dropdown
              id="category-select"
              [options]="getAvailableCategoriesForDropdown()"
              [(ngModel)]="selectedCategoryForNewTag"
              (onChange)="onCategorySelectedForNewTag($event)"
              (onShow)="onCategoryDropdownShow($event)"
              optionLabel="label"
              optionValue="value"
              placeholder="Seleziona categoria"
              [style]="{ width: '100%' }"
              appendTo="body"
              [overlayOptions]="{ baseZIndex: 2200000 }"
              [autoZIndex]="true"
            >
            </p-dropdown>
          </div>
          <div class="form-field" *ngIf="selectedCategoryForNewTag">
            <label for="tag-select">Tag</label>
            <div class="tag-select-with-button">
              <p-dropdown
                id="tag-select"
                [options]="getAvailableTagsForDropdown()"
                [(ngModel)]="selectedTagForNewTag"
                (onChange)="onTagSelectedFromDropdown($event)"
                (onShow)="onTagDropdownShow($event)"
                optionLabel="label"
                optionValue="value"
                [optionDisabled]="'disabled'"
                placeholder="Seleziona tag"
                [style]="{ width: '100%' }"
                appendTo="body"
                [overlayOptions]="{ baseZIndex: 2200000 }"
                [autoZIndex]="true"
              >
                <ng-template let-tagOption pTemplate="item">
                  <div class="tag-option" [class.disabled]="tagOption.disabled">
                    <span>{{ tagOption.label }}</span>
                    <i class="pi pi-check" *ngIf="tagOption.disabled"></i>
                  </div>
                </ng-template>
              </p-dropdown>
              <button
                pButton
                type="button"
                icon="pi pi-plus"
                label="Aggiungi"
                (click)="onAddTagClick()"
                [disabled]="!selectedTagForNewTag"
                class="p-button-primary p-button-sm"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button
        pButton
        type="button"
        label="Chiudi"
        icon="pi pi-times"
        (click)="closeTagsDialog()"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<!-- Dialog Ruoli Referenza -->
<p-dialog
  [(visible)]="showRuoliDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '95vw', maxWidth: '1100px' }"
  styleClass="ruoli-dialog"
  (onHide)="closeRuoliDialog()"
>
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <div class="dialog-title">
        <i class="pi pi-id-card dialog-icon ruoli-dialog-icon"></i>
        <div class="title-content">
          <h2>Ruoli della Referenza</h2>
          <p class="title-subtitle" *ngIf="selectedReferenzaForRuoli">
            {{ selectedReferenzaForRuoli.titoloBreve }}
          </p>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="dialog-content">

    <!-- Loading iniziale -->
    <div class="ruoli-loading" *ngIf="loadingRuoliDialog">
      <i class="pi pi-spin pi-spinner"></i>
      <span>Caricamento in corso...</span>
    </div>

    <ng-container *ngIf="!loadingRuoliDialog">

      <!-- Tabella ruoli assegnati -->
      <p-table
        [value]="getRuoliFlat()"
        [responsiveLayout]="'scroll'"
        styleClass="ruoli-table p-datatable-sm"
      >
        <ng-template pTemplate="header">
          <tr>
            <th style="min-width: 340px;">Ruolo</th>
            <th style="min-width: 200px;">Persona</th>

            <th style="width: 110px; text-align: center;">Firmatario</th>
            <th *ngIf="canModify()" style="width: 70px; text-align: center;"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rp>
          <tr [class.ruolo-row--highlighted]="isRuoloProfiloHighlighted(rp)">

            <td>
              <span class="ruolo-desc-cell">{{ rp.ruoloDescrizione | uppercase }}</span>
            </td>
            <td>
              <div class="ruolo-persona-cell">
<!--                 <i class="pi pi-user ruolo-persona-icon"></i>
 -->                <span style="font-weight: 500; font-weight: bold;">{{ rp.nomeCompleto.toUpperCase() }}</span>
              </div>
            </td>
            <td style="text-align: center;">
              <span
                class="firmatario-icon"
                [ngClass]="rp.firmatario ? 'firmatario-si' : 'firmatario-no'"
                [pTooltip]="rp.firmatario ? 'Firmatario' : 'Non firmatario'"
                tooltipPosition="top"
              >
                <i class="pi" [ngClass]="rp.firmatario ? 'pi-check-circle' : 'pi-minus-circle'"></i>
              </span>
            </td>
            <td *ngIf="canModify()" style="text-align: center;">
              <button
                pButton
                type="button"
                icon="pi pi-trash"
                class="p-button-text p-button-sm p-button-danger"
                pTooltip="Rimuovi assegnazione"
                tooltipPosition="top"
                (click)="confirmRemoveRuoloProfilo(rp)"
              ></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="canModify() ? 4 : 3">
              <div class="empty-ruoli-state">
                <i class="pi pi-id-card empty-icon"></i>
                <p>Nessun ruolo assegnato a questa referenza</p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!-- Form aggiunta nuova assegnazione -->
      <div class="add-ruolo-section" *ngIf="canModify()">
        <div class="add-ruolo-header">
          <i class="pi pi-plus-circle"></i>
          <h4>Aggiungi assegnazione</h4>
        </div>
        <div class="add-ruolo-form">
          <div class="add-ruolo-fields">
            <!-- Riga 1: label -->
            <label class="add-ruolo-label">Ruolo</label>
            <label class="add-ruolo-label">Persona</label>
            <label class="add-ruolo-label" for="newFirmatario">Firmatario</label>
            <!-- Riga 2: controlli -->
            <p-dropdown
              [options]="getRuoliOptions()"
              [(ngModel)]="newRuoloId"
              (onChange)="newProfiloId = null"
              optionLabel="label"
              optionValue="value"
              placeholder="Seleziona ruolo"
              [showClear]="true"
              appendTo="body"
              [overlayOptions]="{ baseZIndex: 2200000 }"
              [autoZIndex]="true"
              [style]="{ width: '100%' }"
            >
              <ng-template let-opt pTemplate="item">
                <span class="ruolo-desc-cell">{{ opt.label | uppercase }}</span>
              </ng-template>
              <ng-template let-opt pTemplate="selectedItem">
                <span class="ruolo-desc-cell">{{ opt.label | uppercase }}</span>
              </ng-template>
            </p-dropdown>
            <div class="persona-input-row">
              <p-dropdown
                [options]="getProfiliOptions()"
                [(ngModel)]="newProfiloId"
                optionLabel="label"
                optionValue="value"
                placeholder="Seleziona persona"
                [showClear]="true"
                [disabled]="!newRuoloId"
                [filter]="true"
                filterPlaceholder="Cerca..."
                appendTo="body"
                [overlayOptions]="{ baseZIndex: 2200000 }"
                [autoZIndex]="true"
                [style]="{ width: '100%' }"
              ></p-dropdown>
              <button
                pButton
                type="button"
                icon="pi pi-user-plus"
                label="Nuovo profilo"
                class="p-button-text p-button-sm add-profilo-inline-btn"
                [disabled]="savingNewProfilo"
                (click)="openCreateProfiloDialog()"
              ></button>
            </div>
            <div class="firmatario-check-wrapper">
              <p-checkbox
                [(ngModel)]="newFirmatario"
                [binary]="true"
                inputId="newFirmatario"
              ></p-checkbox>
            </div>
          </div>
          <button
            pButton
            type="button"
            icon="pi pi-plus"
            label="Aggiungi"
            class="p-button-primary p-button-sm add-ruolo-btn"
            [disabled]="!isNewRuoloFormValid() || savingRuolo"
            [loading]="savingRuolo"
            (click)="addRuoloProfilo()"
          ></button>
        </div>
      </div>

    </ng-container>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button
        pButton
        type="button"
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-text"
        (click)="closeRuoliDialog()"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="showCreateProfiloDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!savingNewProfilo"
  [dismissableMask]="!savingNewProfilo"
  [style]="{ width: '95vw', maxWidth: '420px' }"
  appendTo="body"
  [baseZIndex]="2205000"
  [autoZIndex]="true"
  header="Nuovo profilo"
  styleClass="create-profilo-dialog"
  (onHide)="closeCreateProfiloDialog()"
>
  <div class="create-profilo-form">
    <div class="create-profilo-field">
      <label for="newProfiloNome">Nome</label>
      <input
        pInputText
        id="newProfiloNome"
        type="text"
        [(ngModel)]="newProfiloNome"
        [disabled]="savingNewProfilo"
        maxlength="100"
        autocomplete="off"
      />
    </div>
    <div class="create-profilo-field">
      <label for="newProfiloCognome">Cognome</label>
      <input
        pInputText
        id="newProfiloCognome"
        type="text"
        [(ngModel)]="newProfiloCognome"
        [disabled]="savingNewProfilo"
        maxlength="100"
        autocomplete="off"
      />
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button
        pButton
        type="button"
        label="Annulla"
        class="p-button-text"
        [disabled]="savingNewProfilo"
        (click)="closeCreateProfiloDialog()"
      ></button>
      <button
        pButton
        type="button"
        label="Crea"
        icon="pi pi-check"
        [loading]="savingNewProfilo"
        [disabled]="!isNewProfiloFormValid() || savingNewProfilo"
        (click)="createAndSelectProfilo()"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<!-- Confirm Dialog per eliminazione -->
<p-confirmDialog></p-confirmDialog>

<!-- Dialog Creazione Tag (resta in Home) -->
<app-create-tag-dialog
  [(visible)]="showCreateTagDialog"
  [tags]="allTags"
  [preselectedCategory]="createTagInitialCategory"
  (tagCreated)="onTagCreatedInHome()"
></app-create-tag-dialog>

<!-- Dialog Help Filtri -->
<p-dialog
  [(visible)]="showHelpDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '90vw', maxWidth: '800px' }"
  styleClass="help-dialog"
  (onHide)="closeHelpDialog()"
>
  <ng-template pTemplate="header">
    <div class="help-dialog-header">
      <i class="pi pi-question-circle"></i>
      <h2>Guida all'uso dei filtri</h2>
    </div>
  </ng-template>

  <div class="help-dialog-content">
    <p class="help-intro">
      Utilizza i filtri per trovare rapidamente le referenze che ti interessano. Puoi combinare più filtri per ottenere risultati più precisi.
    </p>

    <div class="help-section">
      <div class="help-section-header">
        <i class="pi pi-search help-section-icon"></i>
        <h3>Ricerca testuale</h3>
      </div>
      <div class="help-section-content">
        <p>
          Il campo di ricerca cerca automaticamente in tutti i campi principali delle referenze:
        </p>
        <ul>
          <li><strong>Titolo breve</strong> e <strong>titolo esteso</strong></li>
          <li><strong>Cliente</strong></li>
          <li><strong>Project Manager</strong></li>
          <li><strong>Numero commessa</strong> (codice commerciale)</li>
          <li><strong>Categorie servizio</strong></li>
          <li><strong>Tag</strong> associati</li>
        </ul>
        <p class="help-note">
          <i class="pi pi-info-circle"></i>
          La ricerca è case-insensitive e trova corrispondenze parziali.
        </p>
      </div>
    </div>

    <div class="help-section">
      <div class="help-section-header">
        <i class="pi pi-check-square help-section-icon"></i>
        <h3>Filtro BIM</h3>
      </div>
      <div class="help-section-content">
        <p>
          Attiva il toggle <strong>BIM</strong> per visualizzare solo le referenze che utilizzano la metodologia BIM.
        </p>
        <p class="help-note">
          <i class="pi pi-info-circle"></i>
          Questo filtro mostra solo le referenze con il campo BIM attivo.
        </p>
      </div>
    </div>

    <div class="help-section">
      <div class="help-section-header">
        <i class="pi pi-link help-section-icon"></i>
        <h3>Filtro Servizi Affini</h3>
      </div>
      <div class="help-section-content">
        <p>
          Attiva il toggle <strong>Servizi Aff.</strong> per visualizzare solo le referenze con servizi affini presenti.
        </p>
        <p class="help-note">
          <i class="pi pi-info-circle"></i>
          Questo filtro mostra solo le referenze con il flag servizi affini attivo.
        </p>
      </div>
    </div>

    <div class="help-section">
      <div class="help-section-header">
        <i class="pi pi-building help-section-icon"></i>
        <h3>Filtri strutturati</h3>
      </div>
      <div class="help-section-content">
        <p>
          I filtri strutturati permettono di selezionare valori specifici da dropdown multipli:
        </p>
        <ul>
          <li>
            <strong>Cliente:</strong> Seleziona uno o più clienti. Se selezioni più clienti, vengono mostrate le referenze che appartengono a <em>qualsiasi</em> cliente selezionato.
          </li>
          <li>
            <strong>Project Manager:</strong> Filtra per uno o più Project Manager. Anche qui, la selezione multipla funziona con logica OR.
          </li>
          <li>
            <strong>Categorie servizio:</strong> Seleziona una o più categorie. Le referenze devono avere <em>almeno una</em> delle categorie selezionate.
          </li>
          <li>
            <strong>Numero Commessa:</strong> Filtra per il codice commerciale della referenza.
          </li>
          <li>
            <strong>Certificato:</strong> Filtra per un codice certificato associato alla referenza.
          </li>
        </ul>
        <p class="help-note">
          <i class="pi pi-info-circle"></i>
          Puoi cercare all'interno dei dropdown digitando il nome dell'opzione.
        </p>
      </div>
    </div>

    <div class="help-section">
      <div class="help-section-header">
        <i class="pi pi-tags help-section-icon"></i>
        <h3>Filtri per Tag</h3>
      </div>
      <div class="help-section-content">
        <p>
          I tag sono organizzati in <strong>gruppi di categorie</strong>:
        </p>
        <ul>
          <li><strong>Servizi:</strong> Categorie di servizi offerti</li>
          <li><strong>Settore:</strong> Settori di intervento</li>
          <li><strong>Tema & Tipologia:</strong> Temi principali e tipologie di progetto</li>
          <li><strong>Strutture & Opere:</strong> Tipi di strutture e altre opere</li>
        </ul>
        <p>
          <strong>Come funzionano i filtri tag:</strong>
        </p>
        <ul>
          <li>All'interno della <strong>stessa categoria</strong>, la selezione multipla funziona con logica <strong>OR</strong> (mostra referenze con <em>almeno uno</em> dei tag selezionati)</li>
          <li>Tra <strong>categorie diverse</strong>, i filtri funzionano con logica <strong>AND</strong> (la referenza deve soddisfare <em>tutte</em> le categorie selezionate)</li>
        </ul>
        <p class="help-example">
          <strong>Esempio:</strong> Se selezioni "Servizi: Progettazione" E "Settore: Sanità", vedrai solo le referenze che hanno <em>entrambi</em> i tag.
        </p>
      </div>
    </div>

    <div class="help-section">
      <div class="help-section-header">
        <i class="pi pi-filter-slash help-section-icon"></i>
        <h3>Gestione filtri</h3>
      </div>
      <div class="help-section-content">
        <ul>
          <li>
            <strong>Chip dei filtri attivi:</strong> Quando hai filtri attivi, vedrai dei chip colorati sopra il titolo "Referenze" che mostrano i filtri applicati. Puoi rimuovere singoli filtri cliccando sulla <i class="pi pi-times" style="font-size: 0.8rem;"></i> sul chip.
          </li>
          <li>
            <strong>Pulsante "Pulisci":</strong> Rimuove tutti i filtri attivi in una volta.
          </li>
          <li>
            <strong>Contatore risultati:</strong> In alto a destra vedrai il numero di referenze totali e quelle filtrate.
          </li>
        </ul>
      </div>
    </div>

    <div class="help-section">
      <div class="help-section-header">
        <i class="pi pi-lightbulb help-section-icon"></i>
        <h3>Suggerimenti</h3>
      </div>
      <div class="help-section-content">
        <ul>
          <li>Inizia con una ricerca testuale per trovare referenze specifiche</li>
          <li>Usa i filtri strutturati per restringere i risultati per cliente, PM o categoria servizio</li>
          <li>Combina i tag per trovare referenze che soddisfano criteri multipli</li>
          <li>Ricorda che i filtri tra categorie diverse si combinano con AND, mentre quelli nella stessa categoria con OR</li>
          <li>Puoi condividere i risultati della ricerca usando il pulsante "Condividi"</li>
        </ul>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Chiudi"
      icon="pi pi-times"
      (click)="closeHelpDialog()"
      class="p-button-text"
    ></button>
  </ng-template>
</p-dialog>

<!-- Dialog di condivisione -->
<p-dialog
  [(visible)]="showShareDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '90vw', maxWidth: '500px' }"
  styleClass="share-dialog"
  (onHide)="closeShareDialog()"
>
  <ng-template pTemplate="header">
    <div class="share-dialog-header">
      <i class="pi pi-share-alt"></i>
      <h2>Condividi ricerca</h2>
    </div>
  </ng-template>

  <div class="share-dialog-content">
    <p class="share-description">
      Scegli come condividere i risultati della tua ricerca:
    </p>

    <div class="share-options">
      <button
        pButton
        type="button"
        icon="pi pi-copy"
        label="Copia URL"
        class="share-option-button"
        (click)="copyUrlToClipboard(); closeShareDialog()"
        [style]="{ width: '100%', marginBottom: '0.75rem' }"
      ></button>

      <div class="share-divider">
        <span>Social</span>
      </div>

      <div class="share-social-row">
        <button
          pButton
          type="button"
          icon="pi pi-whatsapp"
          label="WhatsApp"
          class="share-option-button whatsapp-button"
          (click)="shareViaWhatsApp(); closeShareDialog()"
          [style]="{ flex: '1' }"
        ></button>

        <button
          pButton
          type="button"
          icon="pi pi-envelope"
          label="Email"
          class="share-option-button email-button"
          (click)="shareViaEmail(); closeShareDialog()"
          [style]="{ flex: '1' }"
        ></button>
      </div>

      <div class="share-divider">
        <span>Altri social</span>
      </div>

      <div class="share-social-grid">
        <button
          pButton
          type="button"
          icon="pi pi-linkedin"
          label="LinkedIn"
          class="share-option-button linkedin-button"
          (click)="shareViaLinkedIn(); closeShareDialog()"
          [style]="{ flex: '1' }"
        ></button>

        <button
          pButton
          type="button"
          icon="pi pi-twitter"
          label="Twitter"
          class="share-option-button twitter-button"
          (click)="shareViaTwitter(); closeShareDialog()"
          [style]="{ flex: '1' }"
        ></button>

        <button
          pButton
          type="button"
          icon="pi pi-facebook"
          label="Facebook"
          class="share-option-button facebook-button"
          (click)="shareViaFacebook(); closeShareDialog()"
          [style]="{ flex: '1' }"
        ></button>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Chiudi"
      icon="pi pi-times"
      (click)="closeShareDialog()"
      class="p-button-text"
    ></button>
  </ng-template>
</p-dialog>

